import React, { useState, useEffect } from "react";
import Drawer from 'react-modern-drawer';
import { CommonUtilities } from "../../commonUtils";
import { Filter } from "../../filter";
import { format } from "date-fns";
import PeriodSelectionForm from "../PeriodSelection/periodSelectionForm";
import GenerationAllServices from "./generationAllServices";
import cachingMechanisum from "../Common/cachingMechanisum";
import Pagination from "components/Common/newPagination";
import CurrentJobs from "components/User Profile/CurrentJobs";

export default function StatementHistory(param: any) {
    let [searchFor, setSearchFor] = useState("");
    let [royDateType, setRoyDateType] = useState(1);
    let [reportingEndDate, setreportingEndDate] = useState("");
    let [periodSelected, SetperiodSelected] = useState<any>([]);
    let [periodSelection, setperiodSelection] = useState(false);
    let [reportingStartDate, setreportingStartDate] = useState("");
    let [statmentHistoryRows, setStatmentHistoryRows] = useState(0);
    let [statmentHistoryList, setstatmentHistoryList] = useState<any>([]);
    let [statmentHistoryMethod, setStatmentHistoryMethod] = useState("Email");

    useEffect(() => {

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        //console.log(periodListCache) 
        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }

        if (param.open === true) {

            statementHistoryListing("Email");
            console.log(stsHistory)

            console.log(Filter.DateTimeFormatNumber(periodSelected?.periodFrom))
            setreportingStartDate(String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom)))
            setreportingEndDate(String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)))
        }

    }, [param.open]);

    var stsHistory = {
        SearchFor: searchFor,
        contractRefNum: param?.statementHistoryDetail?.contractRefNum,
        method: statmentHistoryMethod,
        pageSize: 10,
        pageNumber: 1,
        periodFrom: reportingStartDate,
        periodTo: reportingStartDate,
        royDate: royDateType
    }

    const statementHistoryListing = (e: any) => {
        stsHistory.method = e;
        GenerationAllServices.statmentHistoryListing(stsHistory).then((res) => {
            setstatmentHistoryList(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            setStatmentHistoryRows(res && res.totalRows ? res.totalRows : 0);

            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
        })

    }

    const handleNameOnChange = (n: any) => {
        stsHistory.pageNumber = n.pageNumber;
        stsHistory.pageSize = n.pageSize;
    }

    const returnValue = (e: any) => { param.closeStatementHistory(false); }

    const onChange = (period: any) => {

        if (period.periodFrom) {
            console.log(Number(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd')));
        }

        if (period.periodTo) {
            console.log(Number(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd')));
        }

        if (period && period.action && period.action === 2) {

        }
    }

    const closePeriod = (e: any) => {
        console.log(e)
        periodSelection = false;
        setperiodSelection(false)
    }

    const selectPeriod = (e: any) => {
        periodSelection = true;
        setperiodSelection(periodSelection)
    }

    return (
        <>
            <Drawer open={param.open} onClose={() => returnValue(0)} direction={"left"}>

                <div className="pull-right ws-10 box">

                    <div className="box-header bg-blue">
                        <h2 className="ws-4"> Statements History</h2>
                        <CurrentJobs type="calculation" css="white text-bold text-underline" />
                    </div>

                    <div className="ws-12 pm pts">
                        <fieldset className="scheduler-border p0 m0">
                            <legend className="scheduler-border">
                                <h2 style={{ color: "#47529d" }}> <i className="fa fa-sticky-note-o"></i> Statements Info </h2>
                            </legend>

                            <div className="ws-12">

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-4 text-right pr">Contract Code : </label>
                                        <div className="label-entries ws-8">{param?.statementHistoryDetail?.contractRefNum}</div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-4 text-right pr"> Contract Title : </label>
                                        <div className="label-entries ws-8"> {param?.statementHistoryDetail?.contractTitle}</div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-4 text-right pr">  Contact : </label>
                                        {param?.type === 'projectGeneration' && <div className="label-entries ws-8">
                                            {param?.statementHistoryDetail?.contractAccount} ({param?.statementHistoryDetail?.contractAccountCode})
                                        </div>}

                                        {param?.type !== 'projectGeneration' && <div className="label-entries ws-8">
                                            {param?.statementHistoryDetail?.kontactDisplay} ({param?.statementHistoryDetail?.contractArtist})
                                        </div>}

                                    </div>
                                </div>
                            </div>

                        </fieldset>
                    </div>

                    <ul className="nav nav-tabs green-nav-tabs ml pl">
                        <li className={statmentHistoryMethod === 'Email' ? "active nav-horizontal" : "nav-horizontal"} onClick={() => { setStatmentHistoryMethod('Email'); statementHistoryListing("Email"); }}>Email</li>
                        <li className={statmentHistoryMethod === 'Download' ? "active nav-horizontal" : "nav-horizontal"} onClick={() => { setStatmentHistoryMethod('Download'); statementHistoryListing("Download"); }} >Download</li>
                        {false && <li className={statmentHistoryMethod === 'Merge' ? "active nav-horizontal" : "nav-horizontal"} onClick={() => { setStatmentHistoryMethod('Merge'); statementHistoryListing("Merge"); }} >Merge</li>}
                        <li className={statmentHistoryMethod === 'Generate' ? "active nav-horizontal" : "nav-horizontal"} onClick={() => { setStatmentHistoryMethod('Generate'); statementHistoryListing("Generate"); }} >Generate</li>
                    </ul>

                    <div className="ws-12 mbl pl ml pt">

                        <div className="ws-7 pt mt">
                            <input type="text" value={searchFor} placeholder="Type to search" onChange={(e) => setSearchFor(e.target.value)}
                                onKeyDown={(e) => e && e.code && e.code === "Enter" ? statementHistoryListing(statmentHistoryMethod) : ''}
                                className="m0 ws-9 heightReset noBorderRadius height40" />
                            <button className="icon-btn edit ws-2 text-center height40" onClick={() => { statementHistoryListing(statmentHistoryMethod); }}> Search </button>
                        </div>

                        <div className="ws-3">
                            <div className="ws-6">
                                <label className="ws-12">Period From</label>
                                <div className="label-entries mt">
                                    <input type="text" className="ws-11" value={reportingStartDate} placeholder="Start Date" onClick={selectPeriod} />
                                </div>
                            </div>

                            <div className="ws-6">
                                <label ws-1="" className="ws-12">Period To</label>
                                <div className="label-entries mt">
                                    <input type="text" className="ws-11" value={reportingEndDate} placeholder="End Date" onClick={selectPeriod} />
                                </div>
                            </div>
                        </div>

                        <div className="ws-2 mt">
                            <label className="ws-12 mt">
                                <div >
                                    <input type="radio" name="royDate" checked={royDateType === 1} onClick={() => { setRoyDateType(1); stsHistory.royDate = 1; statementHistoryListing(statmentHistoryMethod) }} />Royalty Period
                                </div>
                                <div >
                                    <input type="radio" name="royDate" checked={royDateType === 2} onClick={() => { setRoyDateType(2); stsHistory.royDate = 2; statementHistoryListing(statmentHistoryMethod) }} />Action Date
                                </div>

                            </label>
                        </div>

                    </div>

                    <div className="box-content">

                        <div className="ws-12 text-bold mbl"> Showing ({statmentHistoryRows}) results </div>
                        {statmentHistoryRows === 0 && <div className="alert "> No results found for Email</div>}

                        <div className="allowVscroll allowHscroll " style={{ minHeight: "600px;" }}>

                            {statmentHistoryRows > 0 && <table className="mb borderNone ">
                                <thead>
                                    <tr>
                                        {GenerationAllServices.statementHistoryHeader?.map((value: any) => {
                                            if (value.type.includes(statmentHistoryMethod)) return (<th className="forceSingleLine">{value.headerName}</th>)
                                        })}
                                    </tr>
                                </thead>

                                <tbody>

                                    {statmentHistoryList?.map((listing: any) => {
                                        return (
                                            <tr>
                                                {GenerationAllServices.statementHistoryHeader?.map((value: any) => {
                                                    if (value.type.includes(statmentHistoryMethod)) {
                                                        return (
                                                            <td className="forceSingleLine">
                                                                {value.headerMap === "liveORDraft" && listing[value.headerMap] === "Draft" &&
                                                                    <span className="bg-level10 btn-sm mrl">{listing[value.headerMap]} </span>
                                                                }

                                                                {value.headerMap === "liveORDraft" && listing[value.headerMap] === "Live" &&
                                                                    <span className="icon-btn edit btn-sm mrl">{listing[value.headerMap]} </span>
                                                                }

                                                                {value.headerMap === "method" && listing[value.headerMap] === "merge" &&
                                                                    <span className="bg-level9 btn-sm mrl">{listing[value.headerMap]} </span>
                                                                }

                                                                {value.headerMap === "dateCreated" &&
                                                                    <span> {Filter.DateTimeFormatFullMonth(listing[value.headerMap])}   </span>
                                                                }

                                                                {value.headerMap !== "liveORDraft" && value.headerMap !== "method" && value.headerMap !== "dateCreated" &&
                                                                    <span>{listing[value.headerMap]} </span>
                                                                }
                                                            </td>
                                                        )
                                                    }
                                                })}
                                            </tr>)
                                    })
                                    }
                                </tbody>
                            </table>}
                        </div>

                        <div className="clearfix">
                            {(() => {
                                if (statmentHistoryRows && statmentHistoryRows > 10) {
                                    return <Pagination onPageChange={handleNameOnChange} totalRow={statmentHistoryRows} />;
                                }

                            })()}
                        </div>


                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete width70 height35 pull-right" onClick={returnValue}> Close  </button>
                    </div>

                </div>

                {
                    (() => {
                        if (periodSelection === true) {
                            return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChange} periodFrom={Filter.convertToDateString(reportingStartDate)} periodTo={Filter.convertToDateString(reportingEndDate)} />;
                        }

                    })()
                }

            </Drawer>
        </>
    )
}